import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { z } from 'zod';

import { DEFAULT_PAGE_NUMBER, DEFAULT_LOAD_MORE } from '../../../../constants';
import { clientTransactionsRoute } from '../route';

export const clientTransactionsSiposPageValidateSearchSchema = z.object({
	openedSipo: z.string().optional(),
	pageNumber: z.number().prefault(DEFAULT_PAGE_NUMBER),
	loadMore: z.number().prefault(DEFAULT_LOAD_MORE),
});

export const clientTransactionsSiposRoute = createRoute({
	path: '/sipos',
	getParentRoute: () => clientTransactionsRoute,
	component: lazyRouteComponent(
		() => import('./ClientTransactionsSiposPage'),
		'ClientTransactionsSiposPage',
	),
	validateSearch: clientTransactionsSiposPageValidateSearchSchema,
});
